import React, { Fragment } from 'react';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  id?: string;
}

/**
 * @description Investment round type name select form component.
 * @param {Props} props
 * @return {JSX.Element}
 */
const RequiredIcon = (props: Props): JSX.Element => {
  return (
    <Fragment>
      <FontAwesomeIcon icon={faAsterisk} style={{ color: 'red' }} />
    </Fragment>
  );
};

export default RequiredIcon;
